<template>
    <div>
        <b-modal
            :visible="value"
            size="lg"
            no-close-on-backdrop
            no-close-on-esc
            @cancel="cancel"
            @close="cancel"
            @hidden="hidden"
        >
            <template #modal-title>
                 Week {{unit.order_number}}: {{unit.title}} - Teacher Edition
            </template>

            <div v-if="loading_articles" class="mb-3">
                <b-spinner label="Spinning"></b-spinner>
            </div>
            <div v-else>
                <div v-if="articles && articles.length">
                    <div
                        v-for="article in articles"
                        :key="article.id"
                    >
                        <div class="h6 font-weight-bold">
                            <span
                                class="collapse-icon mr-2"
                                :class="{
                                    'collapsed': !article.visible
                                }"
                                :aria-expanded="article.visible ? 'true' : 'false'"
                                v-b-toggle="'collapse' + article.id"
                            >
                                <span class="open">
                                    <font-awesome-icon :icon="['fas', 'caret-down']" fixed-width />
                                </span>
                                <span class="closed">
                                    <font-awesome-icon :icon="['fas', 'caret-right']" fixed-width />
                                </span>
                                {{article.title}}
                            </span>
                        </div>

                        <b-collapse :id="'collapse' + article.id" visible>
                            <div v-if="article.lesson_plans && article.lesson_plans.length">
                                <div class="border-left pl-3">
                                    <div class="mb-3">
                                        <b-card
                                            v-for="lesson_plan in article.lesson_plans"
                                            :key="lesson_plan.id"
                                        >
                                            <template #header>
                                                Lesson Plan
                                            </template>
                                            <div class="d-flex align-items-center">
                                                <div class="flex-grow-1 mr-3">
                                                    <div v-if="article.has_lesson_plan">
                                                        <div v-if="lesson_plan.lesson_plan">
                                                            <div
                                                                v-html="lesson_plan.lesson_plan"
                                                                class="v-html"
                                                            ></div>
                                                        </div>
                                                        <div v-else class="text-danger">no lesson plan</div>
                                                    </div>
                                                    <div v-else>no data</div>
                                                </div>
                                                <div class="ml-auto">
                                                    <copy-to-clipboard-button
                                                        :value="lesson_plan.lesson_plan"
                                                        :asHtml="true"
                                                        size="sm"
                                                    />
                                                </div>
                                            </div>
                                        </b-card>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="text-warning mb-3">
                                    No lesson plan added for this article
                                </div>
                            </div>
                        </b-collapse>
                    </div>
                </div>
                <div v-else>
                    <b-alert variant="warning" show>
                        0 articles linked to this week
                    </b-alert>
                </div>
            </div>

            <template #modal-footer>
                <b-button
                    variant="light"
                    @click="cancel"
                >
                    Close
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import CopyToClipboardButton from '@/components/CopyToClipboardButton'

export default {
    data: () => ({
        teacher_editions: [],
        articles: [],

        loading_articles: false
    }),
    props: ['value', 'unit', 'publication'],
    components: {
        CopyToClipboardButton
    },
    watch: {
        value: {
            handler (value) {
                if (value) {
                    this.loading_articles = true;
                    this.axios.get('/api/units/article_teacher_editions/' + this.unit.id)
                    .then(response => {
                        this.teacher_editions = response.data;
                        this.sortArticles();
                    })
                }
            }
        }
    },
    methods: {
        sortArticles() {
            _.each(this.teacher_editions.articles, article => {
                var lps = [];
                _.each(article.lesson_plans, lesson_plan => {
                    if(this.publication.id == lesson_plan.pivot.publication_id) {
                        lps.push(lesson_plan);
                        article.has_lesson_plan = true;
                    }
                })

                article.lesson_plans = lps;
            })
            this.articles = this.teacher_editions.articles;
            this.loading_articles = false;
        },
        cancel (event) {
            event.preventDefault()

            this.hide()
        },
        hide () {
            this.$emit('hide')
        },
        hidden () {
            this.$emit('hide')
        }
    }
}
</script>
